import React, { FunctionComponent } from 'react';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconCalendar: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faCalendarAlt} />;

export { BrassIconCalendar };
